import { reactive } from "vue";

type DragHandler = (x: number, y: number, event: MouseEvent) => unknown;

export default (onDrag: DragHandler) => {
  const coords = reactive({
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0
  });

  let bound = false;

  const dispatchOnDrag = (ev: MouseEvent) => onDrag(coords.deltaX, coords.deltaY, ev);

  const setup = () => {
    document.body.style.userSelect = "none";

    if (!bound) {
      window.addEventListener("mouseup", dragEnd);
      window.addEventListener("mousemove", dragMove);

      bound = true;
    }
  };

  const dragStart = (ev: MouseEvent) => {
    setup();

    Object.assign(coords, {
      startX: ev.clientX,
      startY: ev.clientY,

      deltaX: 0,
      deltaY: 0
    });

    dispatchOnDrag(ev);
  };

  const dragMove = (ev: MouseEvent) => {
    coords.deltaX = ev.clientX - coords.startX;
    coords.deltaY = ev.clientY - coords.startY;

    dispatchOnDrag(ev);
  };

  const reset = () => {
    document.body.style.removeProperty("user-select");

    Object.assign(coords, {
      startX: 0,
      startY: 0,
      deltaX: 0,
      deltaY: 0
    });

    if (bound) {
      window.removeEventListener("mouseup", dragEnd);
      window.removeEventListener("mousemove", dragMove);

      bound = false;
    }
  };

  const dragEnd = (ev: MouseEvent) => {
    dispatchOnDrag(ev);
    reset();
  };

  return dragStart;
};
